import { RegisteredTokenDetail } from "models/factory/RegisteredTokenResponse";
import { ConfigResponse } from "models/staking/ConfigResponse";
import { TokenInfoResponse } from "models/token/TokenInfoResponse";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { querySmartContract } from "utils/RpcHelpers";

export type SelectedAsset = {
    tokenAddress?: string,
    stakingAddress?: string,
    owner?: string,
    tokenInfo?: TokenInfoResponse
}

const SelectedAssetContext = createContext<SelectedAsset>({});

export const useAsset = () => useContext(SelectedAssetContext)

export function AssetProvider({ children }: { children: React.ReactNode }) {
    const { pathname } = useLocation()

    useEffect(() => {
        setStakingAddress(getAddress())
    }, [pathname])

    const getAddress = () => {
        const paths = pathname.split("/")
        if (paths.length > 1) {
            const address = paths[1]
            if (address.startsWith("terra")) return address
        }
    }

    const [stakingAddress, setStakingAddress] = useState<string | undefined>()
    const [tokenAddress, setTokenAddress] = useState<string>()
    const [tokenInfo, setTokenInfo] = useState<TokenInfoResponse>()
    const [owner, setOwner] = useState<string>()

    useEffect(() => {
        if (stakingAddress) loadStakingConfig(stakingAddress)
        else {
            setTokenAddress(undefined)
            setTokenInfo(undefined)
            setOwner(undefined)
        }
    }, [stakingAddress])


    const loadStakingConfig = async (address: string) => {
        const { config: { owner, token_contract } }: ConfigResponse = await querySmartContract(address, { config: {} })
        setTokenAddress(token_contract)
        setOwner(owner)

        const tokenInfo: TokenInfoResponse = await querySmartContract(token_contract, { token_info: {} })
        setTokenInfo(tokenInfo)
    }

    return <SelectedAssetContext.Provider value={{
        tokenAddress,
        stakingAddress,
        owner,
        tokenInfo
    }}>
        {children}
    </SelectedAssetContext.Provider>
}